var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-touch-clue"},[_c('div',{staticClass:"visual-touch-clue__text",domProps:{"innerHTML":_vm._s('Тяните вбок,<br>чтобы перемещаться<br>по&nbsp;генплану')}})])}
var staticRenderFns = []

export { render, staticRenderFns }